export function init() {
  setTimeout(() => {
    $('html').addClass('gsa-loaded');
  }, 500);
}